import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Typography } from '@mui/material'

import ImageViewerV2 from '../component/imageViewer/ImageViewerV2'
import { ContainerBox } from '../styles/js/Dashboard.style'
import { FileNodeProp, ImageData } from '../utils/types'
import { get, post } from '../utils/http'
import { LoadingAnimeSpinner } from '../component/common/Loaders'
import { isTokenValid } from '../utils/authVerify'

const StandaloneViewer = () => { 
    const { imageId } = useParams()
    const [imageData, setImageData] = useState<FileNodeProp | {}>({})
    const [image404, setImage404] = useState<boolean>(false)
    const [readonly, setReadonly] = useState<boolean>(false)

    const getImageData = useCallback(async () => {
        try {
            const token = await isTokenValid()
            if (!token) {
                const guest = await post('/auth/guest', {})
                localStorage.setItem('guest-token', guest.token)
                setReadonly(true)
            }
            const image: ImageData | null = isNaN(Number(imageId)) 
                ? await get(`Images/string-id/${imageId}`)
                : await get(`Images/${imageId}`)

            if (image) setTimeout(() => setImageData({...image, file_id: image.image_unique_id}), 0)
            else throw Error("Image Data not found")
        } catch (err) {
            console.log(err)
            setImage404(true)
        }
    }, [imageId])

    useEffect(() => {
        getImageData()
    }, [getImageData])

    const resetMap = () => {
        const temp = {...imageData}
        setImageData({})
        setTimeout(() => setImageData(temp), 0)
    }

    return (
        <ContainerBox className='align-items-center justify-content-center'>
            {image404
                ? <Typography component='h1' variant="h5">Slide not found</Typography>
                : 'id' in imageData
                    ? <ImageViewerV2
                        key={imageData.id}
                        imageProp={imageData}
                        resetMap={resetMap}
                        readonly={readonly}
                    />
                    : <LoadingAnimeSpinner />
            }
        </ContainerBox>
    )
}

export default StandaloneViewer